<template>
  <b-tabs class="m-2 p-2">
    <b-tab title="Allgemein">
      <div style="line-height:200%;">
        <label>CRON Ausdruck:</label><br/>
        <input id="cronexpr" v-model="cron" type="text"/>
        <br/>
        <hr/>
        <table class="datalist" style="font-size:12px;">
          <tr>
            <td><b>Spalte</b></td><td>Sekunden</td><td>Minuten</td><td>Stunden</td><td>Tag des Monats</td><td>Monat</td><td>Tag der Woche</td><td>Jahr</td>
          </tr>
          <tr>
            <td><b>Mögliche Eingaben</b></td><td>0-59 | ,-*/</td><td>0-59 | ,-*/</td><td>0-23 | ,-*/</td><td>1-31 | , - * ? / L W</td><td>1-12 or JAN-DEC | , - * /</td><td>1-7 or SUN-SAT | , - * ? / L #</td><td>empty, 1970-2099 | , - * /</td>
          </tr>
        </table>
        <br/>
        <a target="_blank" href="http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html">Anleitung</a>
      </div>
    </b-tab>
    <!--- STÜNDLICH -->
    <b-tab title="Stündlich">
      <div class="row mt-3">
        <div class="col-md">
          <div class="col-xs-3 form-inline">
              <label class="mr-2">Jede</label>
              <input @change="hourlyCron" class="form-control" size="3" id="hstep" v-model="hourly_every" value="1" type="text"/>
              <label class="ml-2">. Stunde</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md">
          <div class="col-md form-inline">
            <label>Von</label>
            <input @change="hourlyCron" class="form-control ml-3" v-model="hourly_from" type="checkbox" id="hfrom"/>
            <select @change="hourlyCron" class="form-control ml-3 mr-3" v-model="hourly_fromval" id="hfromv">
              <option v-for="h in dataHours" :key="h" :value="h">{{ h }}</option>
            </select>
            <label>Bis</label>
            <input @change="hourlyCron" class="form-control ml-3" v-model="hourly_until" type="checkbox" id="huntil"/>
            <select @change="hourlyCron" v-model="hourly_untilval" class="form-control ml-3" id="huntilv">
              <option v-for="h in dataHours" :key="h" :value="h">{{ h }}</option>
            </select>
          </div>
        </div>
      </div>
    </b-tab>
    <!-- TÄGLICH -->
    <b-tab title="Täglich">
      <div class="row mt-3">
        <div class="form-inline">
          <input @change="dailyCron" class="mr-2" v-model="daily_step" name="days" value="1" checked="" type="radio"/>
          <label>Jeden</label>
          <input @change="dailyCron" v-model="daily_stepval" size="3" value="2" type="text"/>.&nbsp;Tag<br/>
        </div>
      </div>
      <div class="row mt-3">
        <div class="form-inline">
          <input @change="dailyCron" class="mr-2" v-model="daily_step" value="2" name="days" type="radio"/><label>Jeden Arbeitstag (Mo.-Fr.)</label>
        </div>
      </div>
      <div class="row mt-3">
        <div class="form-inline">
          <label>Starten um </label>
          <select @change="dailyCron" class="form-control ml-3" v-model="daily_time" id="dtime">
            <option v-for="h in dataHours" :key="h" :value="h">{{ h }}</option>
          </select>
        </div>
      </div>
    </b-tab>
    <!-- WÖCHENTLICH -->
    <b-tab title="Wöchentlich">
      <div class="row mt-2">
        <div class="col-sm">
          <input @change="weeklyCron" v-model="weekly_days" value="MON" type="checkbox"/>&nbsp;Montag
        </div>
        <div class="col-sm">
          <input @change="weeklyCron" v-model="weekly_days" value="TUE" type="checkbox"/>&nbsp;Dienstag
        </div>
        <div class="col-sm">
          <input @change="weeklyCron" v-model="weekly_days" value="WED" type="checkbox"/>&nbsp;Mittwoch
        </div>
        <div class="col-sm">
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm">
          <input @change="weeklyCron" v-model="weekly_days" value="THU" type="checkbox"/>&nbsp;Donnerstag
        </div>
        <div class="col-sm">
          <input @change="weeklyCron" v-model="weekly_days" value="FRI" type="checkbox"/>&nbsp;Freitag
        </div>
        <div class="col-sm">
          <input @change="weeklyCron" v-model="weekly_days" value="SAT" type="checkbox"/>&nbsp;Samstag
        </div>
        <div class="col-sm">
            <input @change="weeklyCron" v-model="weekly_days" value="SUN" type="checkbox"/>&nbsp;Sonntag
        </div>
      </div>
      <div class="row mt-3">
        <div class="form-inline">
          <label>Starten um </label>
          <select @change="weeklyCron" v-model="weekly_time" class="form-control ml-2" id="wtime">
            <option v-for="h in dataHours" :key="h" :value="h">{{ h }}</option>
          </select>
        </div>
      </div>
    </b-tab>
    <b-tab title="Monatlich">
      <div class="row mt-2">
        <div class="form-inline">
          <input @change="monthlyCron" v-model="monthly_per" value="1" type="radio" class="form-control mr-2" name="month"/>
          <label>Tag</label>
          <input v-model="monthly_mnday" @change="monthlyCron" class="form-control ml-2 mr-2" id="mnday" type="text" size="3"/>
          <label>in jedem</label>
          <input v-model="monthly_mnmon" @change="monthlyCron" class="form-control ml-2 mr-2" type="text" size="3"/>
          <label>Monat</label>
        </div>
      </div>
      <div class="row mt-2">
        <div class="form-inline">
          <input @change="monthlyCron" v-model="monthly_per" value="2" class="form-control mr-2" type="radio" name="month"/>
          <label>Jeden</label>
          <select @change="monthlyCron" v-model="monthly_mwnum" class="form-control mr-2 ml-2">
            <option value="1">ersten</option>
            <option value="2">zweiten</option>
            <option value="3">dritten</option>
            <option value="4">vierten</option>
          </select>
          <select @change="monthlyCron" v-model="monthly_mwday" class="form-control" id="mwday">
            <option value="MON">Montag</option><option value="TUE">Dienstag</option><option value="WED">Mittwoch</option><option value="THU">Donnerstag</option><option value="FRI">Freitag</option><option value="SAT">Samstag</option><option value="SUN">Sonntag</option>
          </select>
          <label>in jedem</label>
          <input @change="monthlyCron" id="mwmon" v-model="monthly_mwmon" type="text" class="form-control" size="3"/>&nbsp;Monat<br/>
        </div>
      </div>
      <div class="row mt-2">
        <div class="form-inline">
          <label>Starten um </label>
          <select @change="monthlyCron" v-model="monthly_time" class="form-control ml-2" id="mtime">
            <option v-for="h in dataHours" :key="h" :value="h">{{ h }}</option>
          </select>
        </div>
      </div>
    </b-tab>
    <!-- JÄHRLICH -->
    <b-tab title="Jährlich">
      <div class="row mt-3">
        <div class="form-inline">
          <label>Starten im</label>
          <select @change="yearlyCron" class="form-control mt-2 ml-2" id="ymon">
            <option v-for="m in monthList" :key="m" :value="m">{{ m }}</option>
          </select>
          <input @change="yearlyCron" id="ydom" type="text" class="mt-2 ml-2 form-control"/>
          <label>.Tag&nbsp;um&nbsp;</label>
          <select @change="yearlyCron" id="ytime" class="form-control mt-2 ml-2">
            <option v-for="h in dataHours" :key="h" :value="h">{{ h }}</option>
          </select>
          <label>Uhr</label>
        </div>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
export default {
  name: 'CronExprBuilder',
  props: ["icron"],
  data() {
    return {
      cron: "",
      hourly_every: "1",
      hourly_from: false,
      hourly_until: false,
      hourly_fromval: "",
      hourly_untilval: "",
      daily_time: 0,
      daily_step: false,
      daily_stepval: "1",
      daily_work: false,
      weekly_time: 0,
      weekly_days: [],
      monthly_per: false,
      monthly_time: 0,
      monthly_mwday: "MON",
      monthly_mnmon: "1",
      monthly_mwnum: "1",
      monthly_mwmon: "1",
      monthly_mnday: "1",
      dataHours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      monthList: ["Januar","Februar","März","April","Mail","Juni","Juli","August","September","Oktober","November","Dezember"],
    }
  },
  watch: {
    icron: function() {
      console.log('update cron: ' + this.icron);
      this.cron = this.icron;
    }
  },
  methods: {
    yearlyCron: function() {

    },
    monthlyCron: function() {
      console.log('monthlycron');
      var cron = '0 0 ' + this.monthly_time;
      if (this.monthly_per == '1') {
        console.log('numeric day');
        cron += ' ' + this.monthly_mnday + " 1/" + this.monthly_mnmon + ' ? *';
      } else {
        console.log('day selection');
        cron += ' ? 1/' + this.monthly_mwmon + ' ' + this.monthly_mwday + '#' + this.monthly_mwnum + ' *';
      }
      this.cron = cron;
      this.$emit('update',cron);
    },
    weeklyCron: function() {
      var cron = '0 0 ';
      var time = this.weekly_time;
      cron += time + ' ? * ';
      var days = '';
      for (var i=0;i<this.weekly_days.length;i++) {
        var item = this.weekly_days[i];
        days += item + ',';
      }
      cron += days.substring(0,days.length-1) + ' *';
      this.cron = cron;
      this.$emit('update',cron);
    },
    dailyCron: function() {
      var cron = '0 0 ';
      var time = Number(this.daily_time);
      cron += time + ' ';
      if (this.daily_step == '1') {
        var step = this.daily_stepval;
        cron += '1/' + step + ' * ? *';
      } else {
        cron += '? * MON-FRI *';
      }
      this.cron = cron;
      this.$emit('update',cron);
    },
    hourlyCron: function() {
      console.log('hourly')
      var start = 0,end   = 23;
      if (this.hourly_from) {
        start = this.hourly_fromval;
      }
      if (this.hourly_until) {
        end = this.hourly_untilval;
      }
      var step = Number(this.hourly_every);
      if (end < start) {
        this.$bvModal.toast('Start kann nicht hinter dem Ende liegen (Stündlich)',{title: 'Scheduler',"variant":"error"});
        return false;
      }
      var cron = '0 0 ';
      while (start <= end) {
        cron  += start + ',';start += Number(step);
      }
      cron = cron.substring(0,cron.length-1);
      cron += ' * * ? *';
      this.cron = cron;
      this.$emit('update',cron);
    }
  }
}
</script>
